export default "__VITE_ASSET__CEMSF_fn__"